<template>
    <div class="body">
        <MenuPage></MenuPage>
        <Dialog v-model:visible="spinnervisible" modal :closable="false" class="alrt">
            <div>
                <ProgressSpinner style="width: 50px; height: 50px; display: block; margin: auto;" strokeWidth="8"
                    fill="transparent" animationDuration=".5s" aria-label="Custom ProgressSpinner" />

                <p>Cargando usuarios</p>
            </div>
        </Dialog>
        <div class="content">
            <DataTable v-model:filters="filters" :value="customers" paginator :rows="7" dataKey="id" filterDisplay="row"
                scrollable scrollHeight="60vh" :globalFilterFields="['Nombre', 'Correo']">

                <template #header>
                    <div class="table-header">
                        <Button label="Agregar Usuario" icon="pi pi-plus" class="p-button-success" @click="OpenModal" />
                    </div>
                </template>

                <Column header="Acciones">
                    <template #body="{ data }">
                        <Button type="button" icon="pi pi-ellipsis-v" @click="onButtonClick($event, data)"
                            aria-haspopup="true" aria-controls="overlay_menu" />
                        <Menu :model="items" :popup="true" v-model:popup="show" appendTo="body" ref="menuRef" />
                    </template>
                </Column>

                <!-- Columna: Nombre -->
                <Column field="name" header="Nombre" style="min-width: 12rem" :filter="true" :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar por nombre..." />
                    </template>
                </Column>

                <!-- Columna: Correo -->
                <Column field="email" header="Correo" style="min-width: 12rem" :filter="true" :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar por correo..." />
                    </template>
                </Column>

                <!-- Columna: Teléfono -->
                <Column field="role" header="Rol" style="min-width: 12rem">
                    <template #body="{ data }">
                        <div class="customfilter"
                            :class="{ bg_admin: data.role == 'admin', bg_operador: data.role == 'operador', bg_facturacion: data.role === 'facturacion' }">
                            {{ data.role }}
                        </div>
                    </template>
                </Column>

                <!-- Columna: Acciones -->

            </DataTable>

            <Dialog v-model:visible="visible2" modal header="Editar Usuario" class="cont-50">

                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-12  m-t-12">
                            <FloatLabel variant="on" class="cont-100">
                                <InputText id="on_label" class="cont-100" v-model="nombre" />
                                <label for="on_label">Nombre</label>
                            </FloatLabel>
                        </div>
                        <div class="col-md-6 col-12  m-t-12">
                            <FloatLabel variant="on">
                                <InputText id="on_label" class="cont-100" v-model="correo" />
                                <label for="on_label">Correo</label>
                            </FloatLabel>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-12  m-t-12">
                            <FloatLabel variant="on">
                                <InputText id="on_label" class="cont-100" type="password" v-model="password" />
                                <label for="on_label">Contraseña</label>
                            </FloatLabel>
                        </div>
                        <div class="col-md-6 col-12  m-t-12">
                            <Select v-model="rol" :options="roles" optionLabel="name" placeholder="Selecciona un Rol"
                                class="cont-95" />
                        </div>
                    </div>
                </div>


                <div class="d-block m-auto cont-95" style="margin-top: 12px;"><br>
                    <Button class="cont-100" raised severity="contrast" @click="editContact()" type="button"
                        label="Editar" icon="pi pi-user-plus" :loading="isloading2" />
                </div>
            </Dialog>

            <Dialog v-model:visible="visible" modal header="Agregar Usuario" class="cont-50">

                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-12  m-t-12">
                            <FloatLabel variant="on" class="cont-100">
                                <InputText id="on_label" class="cont-100" v-model="nombre" />
                                <label for="on_label">Nombre</label>
                            </FloatLabel>
                        </div>
                        <div class="col-md-6 col-12  m-t-12">
                            <FloatLabel variant="on">
                                <InputText id="on_label" class="cont-100" v-model="correo" />
                                <label for="on_label">Correo</label>
                            </FloatLabel>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-12 m-t-12">
                            <FloatLabel variant="on">
                                <InputText id="on_label" class="cont-100" type="password" v-model="password" />
                                <label for="on_label">Contraseña</label>
                            </FloatLabel>
                        </div>
                        <div class="col-md-6 col-12 m-t-12">
                            <Select v-model="rol" :options="roles" optionLabel="name" placeholder="Selecciona un Rol"
                                class="cont-95" />
                        </div>
                    </div>
                </div>


                <div class="d-block m-auto cont-95" style="margin-top: 12px;"><br>
                    <Button class="cont-100" raised severity="contrast" @click="addContact()" type="button"
                        label="Guardar" icon="pi pi-user-plus" :loading="isloading" />
                </div>
            </Dialog>

        </div>
    </div>
</template>


<script setup>
import api from '../plugins/axios';
import MenuPage from './MenuPage.vue';
import InputText from 'primevue/inputtext';
import { onMounted, ref } from 'vue';
import FloatLabel from 'primevue/floatlabel';
import Menu from 'primevue/menu';
import { Dialog, Column, DataTable, Select, Button, ProgressSpinner } from 'primevue';
import { useToast } from 'vue-toastification';
import { nextTick } from 'vue';


const show = ref(false)
const visible = ref(false)
const visible2 = ref(false)
const menuRef = ref(null);
const nombre = ref("");
const correo = ref("");
const password = ref("");
const roles = ref([]);
const isloading = ref(false);
const toast = useToast();
const actualuser = ref([]);
const isloading2 = ref(false);

const filters = ref({
    global: { value: null },
    name: { value: null, matchMode: 'contains' },
    email: { value: null, matchMode: 'contains' },
    rol: { value: null, matchMode: 'contains' },
});

const iduser = ref(0);
const rol = ref(0);
const customers = ref([]);
const spinnervisible = ref(true);

const items = ref([
    {
        label: 'Options',
        items: [
            {
                label: 'Editar',
                icon: 'pi pi-user-edit',
                command: () => {
                    visible2.value = true;
                    iduser.value = actualuser.value.id;
                    nombre.value = actualuser.value.name;
                    correo.value = actualuser.value.email;
                    password.value = "123456";
                    const rolseleccionado = roles.value.find(emp => emp.name === actualuser.value.role);
                    rol.value = rolseleccionado;
                    console.log(actualuser.value)
                }
            },
            {
                label: 'Eliminar',
                icon: 'pi pi-trash',
                command: () => {
                    iduser.value = actualuser.value.id;
                    deleteContact();
                }
            }
        ]
    }
]);


const getUsuarios = async () => {
    try {
        const res = await api.get("/users");
        customers.value = res.data ?? [];
        nextTick(() => {
            spinnervisible.value = false;
        });
    }
    catch (err) {
        console.error(err);
    }
}

const getRoles = async () => {
    try {
        const res = await api.get("/role");
        console.log(res.data)
        roles.value = res.data;
    }
    catch (err) {
        console.error(err);
    }
}

const OpenModal = () => {
    visible.value = true;
}


const addContact = async () => {
    isloading.value = true;
    try {
        if (validar()) {
            const res = await api.post("/save", {
                "name": nombre.value,
                "email": correo.value,
                "password": password.value,
                "role_id": rol.value.id
            });
            if (res.data.status === "success") {

                setTimeout(() => {
                    nombre.value = "";
                    correo.value = "";
                    password.value = "";
                    rol.value = null;
                    isloading.value = false;
                    visible.value = false;
                    getUsuarios();
                    toast.success('Usuario agregado con exito');

                }, 1000);
            }
        }
        else {
            isloading.value = false;
        }
    }
    catch (err) {
        console.error(err);
    }
}

const validar = () => {
    if (nombre.value === '') {
        toast.error("Campo de nombre requerido");
        return false;
    }
    else if (correo.value === "") {
        toast.error("Campo de correo requerido");
        return false;
    }
    else if (password.value === "") {
        toast.error("Campo de contraseña requerido");
        return false;
    }
    else if (rol.value === null) {
        toast.error("Selecciona un rol");
        return false;
    }
    else {
        return true;
    }
}
const editContact = async () => {
    isloading2.value = true;
    try {
        if (validar()) {
            const data = {
                id: iduser.value,
                name: nombre.value,
                email: correo.value,
                role_id: rol.value.id,
            };

            if (password.value !== '123456' && password.value.trim() !== '') {
                data.password = password.value;
            }

            const res = await api.post("/update", data);
            console.log(res.data);

            if (res.data.status === "success") {
                setTimeout(() => {
                    nombre.value = "";
                    correo.value = "";
                    password.value = "";
                    rol.value = null;
                    isloading2.value = false;
                    visible2.value = false;
                    getUsuarios();
                    toast.success('Usuario editado con éxito');
                }, 1000);
            }
        } else {
            isloading2.value = false;
        }
    } catch (err) {
        console.error(err);
        isloading2.value = false;
        toast.error('Error al actualizar el usuario');
    }
};

const deleteContact = async () => {

    try {
        let idactual = localStorage.getItem("id");
        console.log(idactual, iduser.value)
        if (idactual.toString() === iduser.value.toString()) {
            toast.error("El usuario que intentas eliminar es el actual en sesion, accion no permitida");
        }
        else {
            const res = await api.post("/delete", {
                id: iduser.value
            });

            if (res.data.status === "success") {
                toast.success("usuario eliminado con exito");
                getUsuarios();
            }
        }
    }
    catch (err) {
        console.error(err);
    }
}

const onButtonClick = (event, data) => {
    actualuser.value = data;
    show.value = true
    menuRef.value?.toggle(event) // ahora el menú sabe dónde aparecer
}



onMounted(() => {
    getUsuarios();
    getRoles();

});



</script>


<style scoped>
.customfilter {
    width: 100px;
    border-radius: 5px;
    text-align: center;
    padding: 2px;
}

.bg_admin {
    background: rgba(0, 136, 255, 0.362);
    color: rgb(0, 140, 255);
}

.bg_facturacion {
    background: rgb(255, 183, 0);
    color: rgb(255, 255, 255);
}

.bg_operador {
    background: rgba(0, 196, 49, 0.362);
    color: rgb(17, 114, 0);
}
</style>